import React, { useEffect, useState } from "react";
import "./Inner_Products.css";
import All_products from "../../common-components/all-products/All_products";
import Product_card from "../../common-components/common-card/product-card/Product_card";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";
import { useNavigate, useParams } from "react-router-dom";
import { getProducts } from "../../../utils/apis/products/Product";
import { IDS } from "../../../utils/common";
import { Context } from "../../../utils/context";

const Inner_Products = () => {
  const { title } = useParams();

  const newTitle = title
    ? title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
    : "";

  // const data = All_products?.filter((item) => {
  //   return item?.category?.toLowerCase() === title?.toLowerCase();
  // });

  const [data, setData] = useState([]);

  const getProductData = async () => {
    const res = await getProducts();

    if (res?.success) {
      const categoryProducts = res.data.filter(
        (item) => item?.Category?.name?.toLowerCase() === title?.toLowerCase(),
      );

      setData([
        {
          category: title,
          products: categoryProducts,
        },
      ]);
    }
  };

  useEffect(() => {
    getProductData();
  }, [title]);

  const [categories, setCategories] = useState([]);
  const [product, setProduct] = useState([]);

  const getProduct = async () => {
    const res = await getProducts();

    if (res?.success) {
      setProduct(res.data);

      const uniqueCategories = [
        ...new Map(
          res.data.map((item) => [item.Category.id, item.Category]),
        ).values(),
      ];

      const othercats = uniqueCategories?.filter(
        (item) => item?.name !== title,
      );

      setCategories(othercats);
    }
  };

  useEffect(() => {
    getProduct();
  }, [title]);

  console.log("categories", categories);

  const navigate = useNavigate();

  return (
    <section className="Inner_Products">
      <div className="container-fluid">
        <Common_Title_2 titleText={newTitle} />

        {data.map((category) => (
          <div className="row">
            {category.products.map((product, index) => (
              <div
                className="col-lg-3 col-md-4 col-sm-6 col-6 p-1 mb-2"
                key={index}
              >
                <Product_card
                  image={IDS?.IMG_URL + product?.image}
                  price={product?.price}
                  product_name={product?.name}
                  // amazon_link={item.amazon_link}
                  // bigbasket_link={item.bigbasket_link}
                  // blinkit_link={item.blinkit_link}
                  // flipcart_link={item.flipcart_link}
                  platforms={product?.Product_Platforms}
                />
              </div>
            ))}
          </div>
        ))}

        <div className="other_cats_div">
          <Common_Title_2 titleText={"Our Other Products"} />

          <div className="all_cats_holder">
            <div className="row">
              {categories?.map((item) => {
                return (
                  <div className="col-lg-3 col-sm-4 col-6">
                    <div
                      className="cat_img_holder"
                      onClick={() => {
                        navigate(`/products/${item?.name}`);
                      }}
                    >
                      <img
                        src={IDS?.IMG_URL + item?.image}
                        className="cat_img"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inner_Products;
